import { render, staticRenderFns } from "./creditor_details.vue?vue&type=template&id=7c01bf2a"
import script from "./creditor_details.vue?vue&type=script&lang=js"
export * from "./creditor_details.vue?vue&type=script&lang=js"
import style0 from "./creditor_details.vue?vue&type=style&index=0&id=7c01bf2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports